import {inject, Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular/standalone';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private static TOAST_DURATION_IN_MS = 5000;
    private toastController: ToastController = inject(ToastController);
    private translateService: TranslateService = inject(TranslateService);

    constructor() {
    }

    public async showSuccessMessage(message?: string) {
        await this.showToast(message ?? this.translateService.instant("toastMessage.success.retrieve"), "checkmark-circle-outline", "success");
    }

    public async showErrorMessage(message?: string) {
        await this.showToast(message ?? this.translateService.instant("toastMessage.error.retrieve"), "close-circle-outline", "danger");
    }

    private async showToast(message: string, icon: string, color: string) {
        const toast = await this.toastController.create({
            message: message,
            duration: ToastService.TOAST_DURATION_IN_MS,
            position: "bottom",
            icon: icon,
            color: color,
            swipeGesture: "vertical",
            cssClass: "custom-toast",
            buttons: [
                {
                    text: this.translateService.instant("toastMessage.closeAction"),
                    role: "cancel",
                },
            ]
        });

        await toast.present();
    }
}
